import { Field, Formik } from 'formik';
import React, { useContext, useRef, useState, useEffect } from 'react';
import message from 'antd/lib/message';
import Select from 'antd/lib/select';
import { useMutation, useQuery } from 'react-query';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import bookCoverPlaceholder from '../../static/images/placeholders/bookCoverPlaceholder.png';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { FirebaseContext } from '../../context/FirebaseContext';
import AddModalView from './AddModal';
import { useDropDowns } from '../../NecttosComp/APICaller/queryHooks';
import LoadingAnimation from '../../components/LoadingAnimation';
import SearchableImput from '../../NecttosComp/Input/SearchableImput';
import moment from 'moment';
import Button from '../../NecttosComp/Button/Button';
import Input2 from '../../NecttosComp/Input/Input2';
import Instruction from '../../Documentation/Instruction';

const getDDCSubjects = (collegeId, key) => async () => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/college/action/getDDCSubjects', {
			params: { collegeId, key },
		});

		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp?.data?.list;
		}
	} catch (error) {
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};

const getSubjects = (collegeId, key) => async () => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/college/action/getSubjects', {
			params: { collegeId, key },
		});

		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp?.data?.list;
		}
	} catch (error) {
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};

const getTitles = (collegeId, key, isbn) => async () => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/college/action/getTitels', {
			params: { collegeId, key, isbn },
		});

		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			console.log(resp?.data?.list[0].data);
			return resp?.data?.list[0].data;
		}
	} catch (error) {
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};

const { Option } = Select;
async function addBook(data) {
	const storage = getStorage();
	let bookId = data?.bookId;

	const logoImagesRef = ref(storage, `bookCovers/${data.collegeId}/${data?.nameOfBook + moment(new Date()).format('ddd, dd-mm-yyyy hh:mm A')}.png`);
	await uploadBytes(logoImagesRef, data.bookCoverfile, {
		contentType: 'image/png',
	});
	const url = await getDownloadURL(ref(storage, logoImagesRef));
	const instance = await getAxiosTokenInstance();
	data.bookCoverfile = url;

	const resp = await instance.post('/college/libraryOld/addBook', {
		...data,
	});
	return resp.data;
}
async function addToDropDownCollection({ values, title }) {
	const instance = await getAxiosTokenInstance();
	const resp = await instance.post('/college/action/addToDropDowns', {
		key: 'library',
		subKey: title,
		values,
	});
	return resp.data;
}

function AddBook({ onSuccess, allBookList, onCloseModal, editableData }) {
	const { data: dropDown, refetch } = useDropDowns('library');
	const [addModal, setAddModal] = useState(false);

	const { collegeId } = useContext(FirebaseContext);
	const { mutate, isLoading } = useMutation(addBook, {
		onSuccess: (data) => {
			if (data.statusCode === 400) {
				message.error(data.message || 'API Error');
			} else {
				message.success('Book Added');
				onSuccess();
			}
		},
		onError: (error) => {
			message.error(error?.response?.data?.message || error?.message || 'API Error');
		},
	});

	const { mutate: dropsMutate } = useMutation(addToDropDownCollection, {
		onSuccess: (data) => {
			if (data.statusCode === 400) {
				message.error(data.message || 'API Error');
			} else {
				message.success('Added');
				refetch();
				setAddModal(false);
			}
		},
		onError: (error) => {
			message.error(error?.response?.data?.message || error?.message || 'API Error');
		},
	});

	const [showList, setShowList] = useState(false);
	const [showIsbnList, setShowIsbnList] = useState(false);

	const [costom, setCostom] = useState(false);
	const [search, setSearchKey] = useState('');

	const [addModalValue, setAddModalValue] = useState('');
	const [initialVal, setInitialVal] = useState({});
	const [searchBook, setSearch] = useState('');
	const [isbnVal, setIsbn] = useState('');
	const [bookCover, setbookCover] = useState('');

	const [stateData, setStateData] = React.useState({});

	const handleISBNSearch = async ({ bookId }) => {
		try {
			const instance = await getAxiosTokenInstance();
			const resp = await instance.get(`/college/libraryOld/getBookDetails?bookId=${bookId}`);
			if (resp.data.statusCode === 400) {
				throw new Error(resp.data.message || 'API Error');
			}
			if (resp.data.statusCode === 200) {
				if (resp.data.bookDetail.bookId !== bookId) {
					setInitialVal({});
					setStateData({});
				}

				setInitialVal(resp.data.bookDetail);
				setStateData(resp.data.bookDetail);
				setSearch(resp.data.bookDetail && resp.data.bookDetail.nameOfBook);
				setIsbn(resp.data.bookDetail && resp.data.bookDetail.isbn);
				setbookCover(resp.data.bookDetail && resp.data.bookDetail.image);
			}
		} catch (err) {
			message.error('No books found');
		}
	};

	const { data: subjects = [] } = useQuery(['SubjectDrops'], getSubjects(collegeId), { keepPreviousData: true });

	const { data: ddcDrops = [] } = useQuery(['ddcDrops', stateData.subject], getDDCSubjects(collegeId, stateData.subject), { keepPreviousData: true });

	const { data: titlesDropDowns = [] } = useQuery(['titlesDropDowns', stateData.nameOfBook, stateData.isbn], getTitles(collegeId, stateData?.nameOfBook, stateData.isbn), { keepPreviousData: true });

	const fnAddBook = async (data, actions) => {
		if (!data.accessionNumber || data.accessionNumber.trim() === '') {
			message.error('Accession Number cannot be empty');
			actions.setSubmitting(false);
			return;
		}

		console.log(data);
		data.bookCoverfile = bookCover;
		data.bookId = initialVal._id;
		mutate(data);
		actions.setSubmitting(false);
	};

	const useOutsideAlerter = (ref) => {
		useEffect(() => {
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setShowList(false);
				}
			}
			document.addEventListener('mousedown', handleClickOutside);
			return () => {
				document.removeEventListener('mousedown', handleClickOutside);
			};
		}, [ref]);
	};

	const useOutsideAlerter2 = (ref) => {
		useEffect(() => {
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setShowIsbnList(false);
				}
			}
			document.addEventListener('mousedown', handleClickOutside);
			return () => {
				document.removeEventListener('mousedown', handleClickOutside);
			};
		}, [ref]);
	};

	const wrapperRef = useRef(null);
	useOutsideAlerter(wrapperRef);
	const wrapperRef2 = useRef(null);
	useOutsideAlerter2(wrapperRef2);
	const ref = useRef(null);

	const onKeyDown = (keyEvent) => {
		if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
			keyEvent.preventDefault();
		}
	};

	return (
		<>
			{isLoading ? (
				<div className='flex items-center justify-center h-full'>
					<LoadingAnimation />
				</div>
			) : (
				<div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto'>
					<div className='bg-slate-100 dark:bg-neutral-900 rounded-lg shadow-xl w-[95vw] max-w-[1330px] max-h-[100vh] flex flex-col m-4'>
						<div className='flex justify-between items-center p-4 border-b'>
							<span className='text-lg font-semibold dark:text-slate-100'>Add New Book</span>
							<div className='flex justify-end'>
								<Instruction keyId={'addBook'} />
								<Button onClick={onCloseModal} type='close'>
									Close
								</Button>
							</div>
						</div>
						<div className='overflow-auto flex-grow p-4'>
							<Formik
								innerRef={ref}
								initialValues={{
									collegeId,
									isbn: stateData.isbn,
									nameOfBook: stateData.nameOfBook,
									category: stateData.category,
									nameOfAuthor: stateData.nameOfAuthor,
									nameOfAuthor2: stateData.nameOfAuthor2,
									nameOfAuthor3: stateData.nameOfAuthor3,
									authorType: stateData.authorType,
									authorType2: stateData.authorType2,
									authorType3: stateData.authorType3,
									edition: stateData.edition,
									volume: stateData.volume,
									series: stateData.series,
									pages: stateData.pages,
									nameOfPublisher: stateData.nameOfPublisher,
									placeOfPublication: stateData.placeOfPublication,
									yearOfPublication: stateData.yearOfPublication,
									subject: stateData.subject,
									ddcSubject: stateData.ddcSubject,
									ddcNumber: stateData.ddcNumber,
									callNo: stateData.callNo,
									language: stateData.language,
									price: stateData.price,
									discount: stateData.discount,
									invoiceNumber: stateData.invoiceNumber,
									date: stateData.date,
									vendor: stateData.vendor,
									fund: stateData.fund,
									bookDetails: stateData.bookDetails,
									accessionNumber: stateData.accessionNumber,
									status: stateData.status,
									count: stateData.count,
									contents: stateData.contents,
									bookCoverfile: bookCover,
								}}
								enableReinitialize
								onSubmit={fnAddBook}>
								{(props) => (
									<form onSubmit={props.handleSubmit}>
										<div className='flex flex-col lg:flex-row gap-4 p-4 dark:bg-neutral-800 rounded-lg shadow-inner border border-gray-300 dark:border-slate-400 h-full overflow-hidden'>
											<div className='w-full lg:w-[400px]'>
												<div className=' dark:bg-neutral-800 rounded-lg border border-gray-300 dark:border-slate-400 p-4 shadow-sm'>
													<div className='mb-2 relative'>
														<Input2 type='text' fieldName='ISBN' returnKey='isbn' state={stateData} setState={setStateData} onFocus={() => setShowIsbnList(true)} className='w-full' />
													</div>
													<div ref={wrapperRef2}>
														{showIsbnList && stateData?.isbn && titlesDropDowns.length > 0 && (
															<ul className='border rounded mt-1 max-h-60 overflow-auto'>
																{titlesDropDowns.map((item) => (
																	<li
																		key={item._id}
																		className='p-2 hover:bg-gray-100 cursor-pointer text-sm text-green-600'
																		onClick={() => {
																			setStateData({ ...stateData, isbn: item.isbn });
																			handleISBNSearch({ bookId: item._id });
																		}}>
																		{item?.isbn}
																	</li>
																))}
															</ul>
														)}
													</div>

													<div className='mb-2 relative'>
														<Input2 type='text' fieldName='Title of the Book' returnKey='nameOfBook' state={stateData} setState={setStateData} onFocus={() => setShowList(true)} className='w-full' />
													</div>
													<div ref={wrapperRef}>
														{showList && stateData?.nameOfBook && titlesDropDowns?.filter((data) => data?.nameOfBook?.toLowerCase().includes(stateData?.nameOfBook?.toLowerCase())).length > 0 && (
															<ul className='border rounded mt-1 max-h-60 overflow-auto'>
																{titlesDropDowns
																	.filter((data) => data?.nameOfBook?.toLowerCase().includes(stateData?.nameOfBook?.toLowerCase()))
																	.slice(0, 12)
																	.map((item) => (
																		<li
																			key={item._id}
																			className='p-2 hover:bg-gray-100 cursor-pointer text-sm font-semibold text-green-600'
																			onClick={() => {
																				setStateData({ ...stateData, nameOfBook: item.nameOfBook });
																				handleISBNSearch({ bookId: item._id });
																			}}>
																			{`${item?.nameOfBook}, ${item?.nameOfAuthor || ''} [${item?.volume || ''}] [${item?.edition || ''}]`}
																		</li>
																	))}
															</ul>
														)}
													</div>

													<div className='space-y-2'>
														<div className='flex flex-col sm:flex-row sm:items-center'>
															<div className='w-full sm:w-[300px] sm:pr-2'>
																<SearchableImput keyData='nameOfAuthor' titleData='First Author' collection='books' stateData={stateData} setStateData={setStateData} />
															</div>
															<div className='w-full sm:w-[150px]'>
																<SearchableImput keyData='authorType' titleData='Type' collection='books' stateData={stateData} setStateData={setStateData} />
															</div>
														</div>

														<div className='flex flex-col sm:flex-row sm:items-center'>
															<div className='w-full sm:w-[300px] sm:pr-2'>
																<SearchableImput keyData='nameOfAuthor2' titleData='Second Author' collection='books' stateData={stateData} setStateData={setStateData} />
															</div>
															<div className='w-full sm:w-[150px]'>
																<SearchableImput keyData='authorType2' titleData='Type' collection='books' stateData={stateData} setStateData={setStateData} />
															</div>
														</div>

														<div className='flex flex-col sm:flex-row sm:items-center'>
															<div className='w-full sm:w-[300px] sm:pr-2'>
																<SearchableImput keyData='gender' titleData='Third Author' collection='users' stateData={stateData} setStateData={setStateData} />
															</div>
															<div className='w-full sm:w-[150px]'>
																<SearchableImput keyData='authorType3' titleData='Type' collection='books' stateData={stateData} setStateData={setStateData} />
															</div>
														</div>
													</div>

													<div className='mb-2'>
														<Input2 type='drop' fieldName='Subject' returnKey='subject' className='w-full' state={stateData} setState={setStateData} options={subjects?.map((item) => ({ name: item }))} optionDisplay='name' optionKey='name' />
													</div>

													<div className='mb-2'>
														<Input2 type='drop' fieldName='DDC Subject' returnKey='ddcSubject' className='w-full' state={stateData} setState={setStateData} options={ddcDrops?.map((item) => ({ ...item, name: `${item.ddcNumber} - ${item.ddcSubject}` }))} optionDisplay='name' optionKey='ddcSubject' />
													</div>

													<div className='w-full space-y-4'>
														<SearchableImput keyData='nameOfPublisher' titleData='Name of Publisher' collection='books' stateData={stateData} setStateData={setStateData} className='w-full' />
														<SearchableImput keyData='placeOfPublication' titleData='Place of Publication' collection='books' stateData={stateData} setStateData={setStateData} className='w-full' />
														<Input2 type='number' fieldName='Year of Publication' returnKey='yearOfPublication' state={stateData} setState={setStateData} className='w-full' />
													</div>
												</div>
											</div>

											<div className='w-full lg:w-[270px]'>
												<div className=' dark:bg-neutral-800 rounded-lg border border-gray-300 dark:border-slate-400 p-4 shadow-sm'>
													<Input2 type='text' fieldName='Call Number' returnKey='callNo' state={stateData} setState={setStateData} className='w-full mb-2' />

													<div className='flex flex-col sm:flex-row sm:items-center gap-4 mb-4'>
														<div className='w-full sm:w-1/2'>
															<Input2 type='text' fieldName='Edition' returnKey='edition' state={stateData} setState={setStateData} className='w-full' />
														</div>
														<div className='w-full sm:w-1/2'>
															<Input2 type='text' fieldName='Volume' returnKey='volume' state={stateData} setState={setStateData} className='w-full' />
														</div>
													</div>
													<div className='flex flex-col sm:flex-row sm:items-center gap-4 mb-4'>
														<div className='w-full sm:w-1/2'>
															<Input2 type='text' fieldName='Series' returnKey='series' state={stateData} setState={setStateData} className='w-full' />
														</div>
														<div className='w-full sm:w-1/2'>
															<Input2 type='number' fieldName='Pages' returnKey='pages' state={stateData} setState={setStateData} className='w-full' />
														</div>
													</div>

													<Input2 type='number' fieldName='Actual Price' returnKey='price' state={stateData} setState={setStateData} className='w-full mb-5' />
													<Input2 type='number' fieldName='Discount Price' returnKey='discount' state={stateData} setState={setStateData} className='w-full mb-4' />
													<Input2 type='text' fieldName='Invoice Number' returnKey='invoiceNumber' state={stateData} setState={setStateData} className='w-full mb-4' />
													<Input2 type='date' fieldName='Invoice Date' returnKey='date' state={stateData} setState={setStateData} className='w-full mb-4' />
													<SearchableImput keyData='vendor' titleData='Vendor' collection='bookStocks' stateData={stateData} setStateData={setStateData} />
													<SearchableImput keyData='fund' titleData='Fund' collection='bookStocks' stateData={stateData} setStateData={setStateData} />
												</div>
											</div>

											<div className='w-full lg:w-[250px]'>
												<div className='dark:bg-neutral-800 rounded-lg border border-gray-300 dark:border-slate-400 p-4 shadow-sm'>
													<SearchableImput keyData='category' titleData='Category' collection='bookStocks' stateData={stateData} setStateData={setStateData} />
													<SearchableImput keyData='language' titleData='Language' collection='books' stateData={stateData} setStateData={setStateData} />

													<div className='mb-2 mt-4'>
														<Input2 type='number' fieldName='Accession Number' returnKey='accessionNumber' state={stateData} setState={setStateData} className={`w-full ${!stateData.accessionNumber && 'border-red-500'}`} required />
													</div>
													<div className='mb-2'>
														<Input2 type='number' fieldName='Stock' returnKey='count' state={stateData} setState={setStateData} className='w-full' />
													</div>

													<SearchableImput keyData='status' titleData='Status' collection='bookStocks' stateData={stateData} setStateData={setStateData} />
												</div>
												<div className='mt-4'>
													<Input2 type='textarea' fieldName='Contents' returnKey='contents' state={stateData} setState={setStateData} className='w-full lg:w-[480px] mb-4 min-h-[140px] h-[140px]' />
													<Input2 type='textarea' fieldName='Remarks' returnKey='bookDetails' state={stateData} setState={setStateData} className='w-full lg:w-[480px] mb-2 min-h-[140px] h-[140px]' />
												</div>
											</div>

											<div className='lg:ml-5 w-full lg:w-[170px] flex flex-col items-center justify-start'>
												<label className='block mb-4 cursor-pointer'>
													<img src={props.values.bookCoverfile ? (typeof props.values.bookCoverfile === 'string' ? props.values.bookCoverfile : URL.createObjectURL(props.values.bookCoverfile)) : bookCoverPlaceholder} alt='Book cover' className='w-full max-w-[150px] h-[220px] object-cover border rounded shadow-md' />
													<input
														type='file'
														accept='image/*'
														name='bookCoverfile'
														className='hidden'
														onChange={(event) => {
															setbookCover(event.currentTarget.files[0]);
															props.setFieldValue('bookCoverfile', event.currentTarget.files[0]);
														}}
													/>
												</label>
												<Button className='w-full sm:w-auto' type='save'>
													Save
												</Button>
											</div>
										</div>
									</form>
								)}
							</Formik>
						</div>
					</div>
				</div>
			)}
			{addModal && <AddModalView title={addModalValue} onClose={() => setAddModal(false)} onExport={(values, title) => dropsMutate({ values, title })} />}
		</>
	);
}

export default AddBook;
